const htmlToText = (htmlString) => {
  const parser = new DOMParser();
  const parsedHtml = parser.parseFromString(htmlString, "text/html");
  return parsedHtml.body.innerText || "";
};

export default htmlToText;
